import type { JSX } from "react";
import { useEffect } from "react";
import { usePresenceStore } from "@/state/usePresenceStore";

const COLORS: Record<string, string> = {
  available: "text-phosphor border-phosphor",
  limited: "text-amber border-amber",
  booked: "text-magenta border-magenta",
};

export const StatusBadge = (): JSX.Element => {
  const status = usePresenceStore((s) => s.status);
  const note = usePresenceStore((s) => s.note);
  const load = usePresenceStore((s) => s.load);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border px-2 py-0.5 font-mono text-xs uppercase ${COLORS[status] ?? COLORS.available}`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />
      {status} · {note}
    </div>
  );
};
